// src/redux/slices/teamMessageSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: [], // list of team messages
  loading: false,
  error: null
};

export const teamMessageSlice = createSlice({
  name: 'teamMessage',
  initialState,
  reducers: {
    addTeamMessage: () => {},
    getTeamMessages: () => {},
    getOneTeamMessage: () => {},
    updateTeamMessage: () => {},
    removeTeamMessage: () => {},

    // successTeamMessage: (state, action) => {
    //   state.data = action.payload;
    //   state.loading = false;
    //   state.error = null;
    // },
    successTeamMessage: (state, action) => {
      state.data = Array.isArray(action.payload) ? action.payload : state.data; // 🔥 keep old list if payload not array
    },

    failedTeamMessage: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setLoadingTeamMessage: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const {
  addTeamMessage,
  getTeamMessages,
  getOneTeamMessage,
  updateTeamMessage,
  removeTeamMessage,
  successTeamMessage,
  failedTeamMessage,
  setLoadingTeamMessage
} = teamMessageSlice.actions;

export default teamMessageSlice.reducer;
